// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { ListTestIds } from '@trello/test-ids';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('card_composer_inline');

export const CardComposerInlineTemplate = () => {
  const placeholder = t.mustacheVar('placeholder');

  t.div('.list-card.js-composer', () =>
    t.div('.list-card-details.u-clearfix', function () {
      t.div('.list-card-labels.u-clearfix.js-list-card-composer-labels');
      t.textarea(
        '.list-card-composer-textarea.js-card-title',
        {
          dir: 'auto',
          placeholder,
          'data-testid': ListTestIds.CardComposerTextarea,
        },
        () => t.text(t.mustacheVar('title')),
      );
      return t.div('.list-card-members.js-list-card-composer-members');
    }),
  );

  return t.div('.cc-controls.u-clearfix', function () {
    t.div('.cc-controls-section', function () {
      t.input(
        '.nch-button.nch-button--primary.confirm.mod-compact.js-add-card',
        {
          type: 'submit',
          value: t.l('add-card'),
        },
      );
      return t.a('.icon-lg.icon-close.dark-hover.js-cancel', { href: '#' });
    });

    return t;
  });
};
